import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { textToClipboard } from '@vs/functions/text-to-clipboard';
import { showToast } from '@vs/rtk/slices/genericGlobal';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

type PropsCodeBlock = {
  children?: string;
  className?: string;
  enableCopy?: boolean;
};

export function CodeBlock({
  children = '',
  className = '',
  enableCopy = false,
}: PropsCodeBlock) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  function handleCopy() {
    textToClipboard(children).then(() =>
      dispatch(
        showToast({
          message: t('shared:system.toast.copied', { defaultValue: 'Copied' }),
        })
      )
    );
  }

  return (
    <div
      className={classNames(
        'mockup-code mt-4 px-4 before:hidden relative',
        className
      )}
    >
      {enableCopy && (
        <ContentCopyIcon
          className="absolute top-4 right-4 cursor-pointer"
          onClick={handleCopy}
        />
      )}
      <code className="whitespace-pre-wrap">{`${children}`}</code>
    </div>
  );
}
